import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { api } from '../../common';
import { ClientDiagnosticsService, SKIP_CLIENT_DIAGNOSTICS } from '../services/client-diagnostics.service';

export const clientDiagnosticsInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_CLIENT_DIAGNOSTICS) || !req.url.startsWith(api)) {
    return next(req);
  }

  const diagnostics = inject(ClientDiagnosticsService);
  const path = diagnostics.toApiPath(req.url);

  return next(req).pipe(
    tap({
      next: (event) => {
        if (!(event instanceof HttpResponse)) {
          return;
        }

        if (event.status >= 500) {
          diagnostics.trackApi(
            'api.response.server_error',
            {
              method: req.method,
              path,
              status: event.status,
              requestId: event.headers.get('x-request-id') || undefined,
            },
            'error',
          );
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status !== 401 && error.status !== 403 && error.status < 500) {
          return;
        }

        diagnostics.trackApi(
          'api.response.error',
          {
            method: req.method,
            path,
            status: error.status,
            requestId: error.headers?.get('x-request-id') || undefined,
            message: error.error?.message || error.message,
          },
          error.status >= 500 ? 'error' : 'warn',
        );
      },
    }),
  );
};
